import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CustomFilterControl {
    customFilterControl: boolean;
}

const initialState: CustomFilterControl = {
    customFilterControl: false,
};

const customFilterSlice = createSlice({
    name: 'customFilter',
    initialState,
    reducers: {
        isCustomFilterControl: (state, action: PayloadAction<boolean>) => {
            state.customFilterControl = action.payload;
        },
    },
});

export const { isCustomFilterControl } = customFilterSlice.actions;

export default customFilterSlice.reducer;
